import { useState } from "react";
import {
  Button,
  Card,
  Text,
  Spinner,
  MessageBar,
  MessageBarBody,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { useAuth } from "../contexts/AuthContext";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    background: tokens.colorNeutralBackground2,
    padding: "1rem",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "400px",
    width: "100%",
    padding: "2.5rem",
    textAlign: "center",
    gap: "1rem",
  },
  icon: {
    fontSize: "3.5rem",
    lineHeight: 1,
  },
  msIcon: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
});

const MicrosoftLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    width="20"
    height="20"
  >
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

export function LoginPage() {
  const { login, error } = useAuth();
  const [signing, setSigning] = useState(false);
  const styles = useStyles();

  const handleLogin = async () => {
    setSigning(true);
    try {
      await login();
    } finally {
      setSigning(false);
    }
  };

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <div className={styles.icon} role="img" aria-label="lock">
          🔐
        </div>
        <Text size={500} weight="semibold">
          Welcome to RFP Assistant
        </Text>
        <Text size={300}>
          Sign in with your Microsoft account to start chatting with the AI
          assistant.
        </Text>
        <Button
          appearance="primary"
          size="large"
          onClick={handleLogin}
          disabled={signing}
          icon={
            signing ? (
              <Spinner size="tiny" />
            ) : (
              <span className={styles.msIcon}>
                <MicrosoftLogo />
              </span>
            )
          }
        >
          {signing ? "Signing in..." : "Sign in with Microsoft"}
        </Button>
        {error && (
          <MessageBar intent="error">
            <MessageBarBody>{error}</MessageBarBody>
          </MessageBar>
        )}
      </Card>
    </div>
  );
}
